import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../services/api';
import LazyImage from '../components/LazyImage';
import { RotatingLines } from 'react-loader-spinner';
import { FaPaypal, FaStripe, FaExternalLinkAlt } from 'react-icons/fa';

const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.large};
  margin: 0 auto;
  padding: 2rem;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1rem;
`;

const ContentSection = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadows.medium};
  text-align: center;
`;

const InfoText = styled.div`
  margin-bottom: 2rem;
  white-space: pre-wrap;
  font-size: 1.1rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  
  @media (min-width: 500px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const DonateButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  background-color: ${({ $color }) => $color || '#333'};
  color: white;
  border-radius: 50px;
  text-decoration: none;
  font-weight: bold;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-3px);
    opacity: 0.9;
  }
`;

const Donate = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/donate')
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{display:'flex', justifyContent:'center', marginTop:'50px', minHeight:'100vh'}}>
      <RotatingLines strokeColor="grey" width="50" />
    </div>
  );

  if (!data) return <div>Error</div>;

  return (
    <Container>
       <HeaderSection>
          {data.image && (
            <div style={{height: '300px', marginBottom: '2rem', borderRadius:'8px', overflow:'hidden'}}>
                <LazyImage src={data.image} alt={data.title} />
            </div>
          )}
          <Title>{data.title}</Title>
          <p>{data.description}</p>
       </HeaderSection>

       <ContentSection>
          <InfoText>{data.infoText}</InfoText>
          <ButtonGroup>
            <div style={{width:'100%', marginBottom:'1rem'}}>
              <givebutter-widget id="LylJ2A"></givebutter-widget>
            </div>
            
          </ButtonGroup>
       </ContentSection>
    </Container>
  );
};

export default Donate;
